var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassesMediumOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 14.6668H10.6654M13.6654 7.00016C13.6654 10.1298 11.1283 12.6668 7.9987 12.6668C4.86908 12.6668 2.33203 10.1298 2.33203 7.00016C2.33203 3.87055 4.86908 1.3335 7.9987 1.3335C11.1283 1.3335 13.6654 3.87055 13.6654 7.00016ZM10.1237 7.00016C10.1237 8.17377 9.1723 9.12516 7.9987 9.12516C6.82509 9.12516 5.8737 8.17377 5.8737 7.00016C5.8737 5.82656 6.82509 4.87516 7.9987 4.87516C9.1723 4.87516 10.1237 5.82656 10.1237 7.00016Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassesMediumOnline);
export default __webpack_public_path__ + "static/media/ClassesMediumOnline.42b8a9301b20cceb0257cce8df1706ea.svg";
export { ForwardRef as ReactComponent };